"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Input = styled_components_1.default.input `
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.designSystem.white};
  line-height: 1.5;

  padding: 0 0 7px 0;
  margin: 0;
  box-sizing: border-box;

  background-color: transparent;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.designSystem.white};
  border-radius: 0;

  &:focus-visible {
    outline: none;
    border-bottom: 1px solid ${({ theme }) => theme.designSystem.accent};
  }

  @supports not selector(:focus-visible) {
    &:focus {
      /* Fallback for browsers without :focus-visible support */
      outline: none;
      border-bottom: 1px solid ${({ theme }) => theme.designSystem.accent};
    }
  }
`;
